/* eslint-disable */
import EntityManager from "../EntityManager";
import DirectionEntity from "../Entity/Direction";
import RestTypesRepository from "../Repository/RestTypes";

let DirectionFactory = function(options) {
	var direction = new DirectionEntity(),
		entityManager = new EntityManager(),
		data = options.data,
		prices = options.prices,
		restTypes,
		element;

	if(prices && prices[data['directionId']]) {
		direction.set('price', prices[data['directionId']]);
	}

	element = data['link'];
	if(typeof element != "undefined") {
		direction.set('link', element);
	}
	
	element = data['cover'];
	if(typeof element != "undefined") {
		direction.set('cover', element);
	}

	element = data['title'];
	if(typeof element != "undefined") {
		direction.set('directionTitle', element);
	}

	element = data['directionId'];
	if(typeof element != "undefined") {
		direction.set('directionId', element);
	}

	element = data['restTypes'];
	if(typeof element != "undefined" && element.length) {
		restTypes = entityManager.get(RestTypesRepository, element);
		direction.set('restTypes', restTypes);
	}
	
	return direction;
};

export default DirectionFactory